export default __webpack_public_path__ + "static/selfapp-736-mobile-f11f78f0a3939d9abd16d963805f8a9f.jpg";